import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Lock } from 'lucide-react';
export function PriceBlock() {
  return <section id="pricing" className="py-24 bg-sage-dark text-cream relative overflow-hidden" data-id="element-133">
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-134"></div>

      <div className="max-w-5xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-135">
        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl flex flex-col md:flex-row items-center gap-12" data-id="element-136">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="w-full md:w-1/2 flex justify-center" data-id="element-137">
            <img src="https://cdn.magicpatterns.com/uploads/6z2upji7HUiqywbwX9LxZn/heylloyd-image-1776034671398.png" alt="Eco-S.O.S. Detox eBook" className="w-full max-w-sm rounded-xl drop-shadow-xl" data-id="element-138" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="w-full md:w-1/2 text-center md:text-left" data-id="element-139">
            <h2 className="text-3xl md:text-4xl font-serif text-dark mb-4" data-id="element-140">
              Comienza tu transformación hoy
            </h2>
            <p className="text-dark/70 text-lg mb-8" data-id="element-141">
              Hoy puedes obtener acceso inmediato al eBook completo por un
              precio accesible para recuperar tu energía, eliminar la hinchazón
              y sentirte tú misma de nuevo.
            </p>

            <div className="mb-8" data-id="element-142">
              <span className="text-2xl font-serif text-dark/40 line-through mr-3" data-id="element-143">
                $20
              </span>
              <span className="text-5xl font-serif text-sage-dark font-bold" data-id="element-144">
                $6.38
              </span>
              <span className="text-dark/50 ml-2" data-id="element-145">USD</span>
              <span className="ml-3 inline-block bg-red-100 text-red-600 text-sm font-bold px-3 py-1 rounded-full" data-id="element-146">
                -76% OFF
              </span>
            </div>

            <a href="https://esenciaactiva.it.com/cart/44026659700772:1" id="pricing-cta" className="w-full md:w-auto flex flex-col items-center justify-center px-10 py-5 bg-sage hover:bg-sage-dark text-white rounded-2xl font-medium transition-all duration-300 shadow-lg shadow-sage/30 group no-underline" data-id="element-147">
              <span className="flex items-center text-xl mb-1" data-id="element-148">
                Obtener Eco-S.O.S. Detox Ahora
                <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-149" />
              </span>
              <span className="text-sm text-white/80 font-normal" data-id="element-150">
                Descarga instantánea, empieza hoy mismo.
              </span>
            </a>

            <div className="mt-6 flex items-center justify-center md:justify-start text-dark/50 text-sm" data-id="element-151">
              <Lock className="w-4 h-4 mr-2" data-id="element-152" />
              Pago 100% seguro y encriptado
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}